import { useTranslation } from 'react-i18next';
import { Button } from '@web/shared/ui/button';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 text-center">
      <p className="text-muted-foreground text-6xl font-semibold">404</p>
      <h1 className="type-subtitle1">{t('errors.notFound.title')}</h1>
      <Button onClick={() => globalThis.history.back()}>{t('common.back')}</Button>
    </div>
  );
}
